import { useState } from 'react'
import { errorMessage, scheduleLesson } from '../../../services/admin'
import { toDatetimeLocal, formatDatetime } from '../dates'

// ─── Schedule picker (inline in a lesson card) ────────────────────────────────

export function SchedulePicker({ lesson, onUpdate }) {
  const [open, setOpen] = useState(false)
  const [val, setVal] = useState(lesson.scheduledPublishAt ? toDatetimeLocal(lesson.scheduledPublishAt) : '')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')

  async function save(e) {
    e.preventDefault()
    setBusy(true); setErr('')
    try {
      const iso = val ? new Date(val).toISOString() : null
      onUpdate(await scheduleLesson(lesson.id, iso))
      setOpen(false)
    } catch (ex) { setErr(errorMessage(ex)) }
    finally { setBusy(false) }
  }

  async function clear() {
    setBusy(true); setErr('')
    try {
      onUpdate(await scheduleLesson(lesson.id, null))
      setVal(''); setOpen(false)
    } catch (ex) { setErr(errorMessage(ex)) }
    finally { setBusy(false) }
  }

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)}
        className="flex items-center gap-1 rounded-lg px-2 py-1 text-xs text-ink-2 hover:bg-surface-2">
        <span>📅</span>
        <span>{lesson.scheduledPublishAt ? formatDatetime(lesson.scheduledPublishAt) : 'زمان‌بندی'}</span>
      </button>
    )
  }

  return (
    <form onSubmit={save} className="flex flex-wrap items-center gap-2 rounded-lg bg-surface-2 px-3 py-2">
      <input type="datetime-local" value={val} onChange={e => setVal(e.target.value)}
        className="rounded-lg border border-line-2 bg-surface px-2 py-1 text-xs text-ink focus:border-brand-500 focus:outline-none" />
      <button type="submit" disabled={busy || !val}
        className="rounded-lg bg-brand-600 px-2.5 py-1 text-xs font-semibold text-on-ink disabled:opacity-40">
        {busy ? '…' : 'ذخیره'}
      </button>
      {lesson.scheduledPublishAt && (
        <button type="button" onClick={clear} disabled={busy}
          className="rounded-lg border border-line-2 px-2.5 py-1 text-xs text-ink-2 hover:bg-surface disabled:opacity-40">
          حذف
        </button>
      )}
      <button type="button" onClick={() => setOpen(false)}
        className="text-xs text-ink-3 hover:text-ink">✕</button>
      {err && <span className="text-xs text-bad-ink">{err}</span>}
    </form>
  )
}
